export default {"src":"/_next/static/media/svenskinsamlingskontroll.019aef9b.svg","height":152,"width":615,"blurWidth":0,"blurHeight":0};